export default __webpack_public_path__ + "static/media/ic_map_turkiye_hub.da633f17.svg";